/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ProviderRatingTypeEnum =
  (typeof ProviderRatingTypeEnum)[keyof typeof ProviderRatingTypeEnum];

export const ProviderRatingTypeEnum = {
  rating: 'rating',
} as const;
